import React from "react";
import { PeekStack } from "@piiqtechnologies/ui-components";
export const WidgetLoader = ({ minHeight = 200, size = 48 }) => {
    return (React.createElement(PeekStack, { justifyContent: "center", alignItems: "center", sx: { width: "100%", minHeight } },
        React.createElement("img", { src: "/images/spinner.gif", width: size, height: size, alt: "Loading" })));
};
export default WidgetLoader;
